import React from "react";
import { Link } from 'react-router-dom';

import PageHeaderContent from "../../components/pageHeaderContent";
import { BsInfoCircleFill } from "react-icons/bs";
import ImageOne from "../../images/portfolioImg/image1.jpg";
import ImageTwo from "../../images/portfolioImg/image2.jpg";
// import ImageThree from "../../images/portfolioImg/image3.jpg";
// import ImageFour from "../../images/portfolioImg/image4.jpg";
// import ImageFive from "../../images/portfolioImg/image5.jpg";
import "./styles.scss";
import { useState } from "react";

const portfolioData = [
  {
    // id: 2,
    name: "Language Construction",
    image: ImageTwo,
    to: 'https://github.com/MuhammadHaziq12/compiler-construction-project'
  },
  {
    id: 2,
    name: "Laravel Admin Panel",
    image: ImageOne,
    to: 'https://github.com/MuhammadHaziq12/Laravel-E-Commerce-Admin-Panel'

  },
  // {
  //   id: 2,
  //   name: "React Todo App",
  //   image: ImageThree,
  //   to: 'http://google.com'
    
  // },
  // {
  //   id: 2,
  //   name: "Todo App",
  //   image: ImageFour,
  //   to: 'http://youtube.com'

  // },
  // {
  //   id: 3,
  //   name: "Shopping cart design",
  //   image: ImageFive,
  //   to: 'http://youtube.com'

  // },
];

const filterData = [
  {
    filterId: 1,
    label: "All",
  },
  {
    filterId: 2,
    label: "Websites",
  },
  {
    filterId: 3,
    label: "Mobile App",
  },
  
];

const Portfolio = () => {
  const [filteredvalue, setFilteredValue] = useState(1);
  const [hoveredValue, setHoveredValue] = useState(null);

  function handleFilter(currentId) {
    setFilteredValue(currentId);
  }

  function handleHover(index) {
    setHoveredValue(index);
  }

  console.log("====================================");
  console.log(hoveredValue);
  console.log("====================================");

  const filteredItems =
    filteredvalue === 1
      ? portfolioData
      : portfolioData.filter((item) => item.id === filteredvalue);

  console.log(filteredItems);

  return (
    <section id="portfolio" className="portfolio">
      <PageHeaderContent
        headerText="My Portfolio"
        icon={<BsInfoCircleFill size={40} />}
      />
      <div className="portfolio__content">
        <ul className="portfolio__content__filter">
          {filterData.map((item) => (
            <li
              className={item.filterId === filteredvalue ? "active" : ""}
              onClick={() => handleFilter(item.filterId)}
              key={item.filterId}
            >
              {item.label}
            </li>
          ))}
        </ul>
        <div className="portfolio__content__cards">
          {filteredItems.map((item, index) => (
            <div
              className="portfolio__content__cards__item"
              key={`cardItem${item.name.trim()}`}
              onMouseEnter={() => handleHover(index)}
              onMouseLeave={() => handleHover(null)}
            >
              <div className="portfolio__content__cards__item__img-wrapper">
                <a>
                  
                  <img alt="dummy data" src={item.image} />
                </a>
              </div>
              <div className="overlay">
                {index === hoveredValue && (
                  <div>
                    <p>{item.name}</p>
                    <Link  to={item.to}>
                    <button>github</button>
                    </Link>
                    
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default Portfolio;
